<oc-app-frame
    hasDrawerMenu
    [showFooter]="false"
    [showDateTime]="false"
>
    <img
        routerLink="/"
        ocBrandIcon
        alt="Orgacard Logo"
        width="200px"
        src="assets/logo_orgacard_desktop.svg"
    />

    <mat-nav-list ocDrawerMenu>
        <mat-list-item
            *ngFor="let link of links"
            [routerLink]="link.url"
            routerLinkActive="active"
        >
            <mat-icon matListItemIcon>{{ link.icon }}</mat-icon>
            {{ link.text }}
        </mat-list-item>
    </mat-nav-list>

    <ng-container ocIconMenu>
        <button
            mat-icon-button
            class="align-self-center"
            *ngFor="let iconMenuItem of iconMenuItems$ | async"
        >
            <mat-icon
                class="d-block align-self-center"
                matBadgeColor="warn"
                matBadgePosition="below after"
                [matBadge]="iconMenuItem.badge"
                [matBadgeHidden]="!(iconMenuItem.badge ?? 0 > 0)"
            >
                {{ iconMenuItem.icon }}
            </mat-icon>
        </button>

        <oc-icon-menu
            [items]="iconDropDownMenu"
            icon="oc-gender-male"
            #iconMenu
        >
            <ng-container *ocIconMenuItemDef="let item">
                <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
                <ng-container *ngIf="item.id === 'user'; else tplDefault">
                    <div class="flex flex-col p-2">
                        <span class="d-block">{{ currentUser$ | async }}</span>
                        <span class="d-block">Angemeldet für: {{ mandator$ | async }}</span>
                    </div>
                </ng-container>
                <ng-template #tplDefault>
                    <span (click)="onMenuItemClick(item)">{{ item.text }}</span>
                </ng-template>
            </ng-container>
        </oc-icon-menu>
    </ng-container>

    <div class="outer-main bg-yellow">
        <oc-bms-client-loading-spinner *ngIf="loading$ | async"></oc-bms-client-loading-spinner>
        <div class="d-flex main-bar border-bottom align-items-center">
            <div class="flex-fill">
                <oc-bms-client-breadcrumb></oc-bms-client-breadcrumb>
            </div>
            <div class="flex-shrink-1">
                <ng-template [cdkPortalOutlet]="extraButtons$ | async"></ng-template>
                <button
                    class="bg-primary text-white p-2"
                    bmsClientBackButton
                >
                    <mat-icon>oc-circle-filled-left</mat-icon>
                </button>
            </div>
        </div>
        <main class="p-0 pt-5 bg-yellow">
            <router-outlet></router-outlet>
        </main>
    </div>
</oc-app-frame>
